import {Selector} from '@ngxs/store';
import {BillingState} from './billing.state';
import {BillingStateModel} from '@store/billing/billing-state.model';
import {IBillingOperations} from '@interfaces/billing';
import {IResponse} from '@interfaces/response';

export class BillingSelectors {
  @Selector([BillingState])
  static getBillingOperationsTvOwner(state: BillingStateModel): IResponse<IBillingOperations> | null {
    return state.operations;
  }

  @Selector([BillingState])
  static getBillingTvOwnerSearchValue(state: BillingStateModel): string {
    return state.searchParam;
  }

  @Selector([BillingState])
  static getBillingTvOwnerPage(state: BillingStateModel): number {
    return state.currentPage;
  }

  @Selector([BillingState])
  static getBillingTvOwnerPerPage(state: BillingStateModel): number {
    return state.itemsPerPage;
  }

  @Selector([BillingState])
  static getBillingTvOwnerLoader(state: BillingStateModel): boolean {
    return state.loader;
  }

  @Selector([BillingState])
  static getTvOwnerBalance(state: BillingStateModel): number {
    return state.balance;
  }
}
